import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Box3, Color, Vector3 } from "three";
import { v3 } from "oc-threejs/short3";
import { Stromkabel3d } from "../arrangement3d/Stromkabel3d";
import { TRAFO_KABELLÄNGE } from "./lichtleistenFunctions";
import { Aufbau } from "./Aufbau";

export class Stromkabel extends Jaco {
  static CLASS_NAME = "Stromkabel";

  trafo: Aufbau;
  länge = 0;
  pfad: Vector3[] = [];
  lichtAnschlüsse: Vector3[] = [];
  startAnschluss: "Trafo" | "Bus" | null = null;
  endAnschluss: "Bus" | null = null;
  index = 0;
  schlaufen = 0;

  box: Box3;

  init(
    trafo: Aufbau,
    länge: number,
    pfad: Vector3[],
    lichtAnschlüsse: Vector3[],
    startAnschluss: "Trafo" | "Bus" | null,
    endAnschluss: "Bus" | null,
    index: number,
    schlaufen: number
  ) {
    this.trafo = trafo;
    this.länge = länge;
    this.pfad = pfad;
    this.lichtAnschlüsse = lichtAnschlüsse;
    this.startAnschluss = startAnschluss;
    this.endAnschluss = endAnschluss;
    this.index = index;
    this.schlaufen = schlaufen;
    this.box = new Box3().setFromPoints(pfad);
  }
  get color(): Color {
    const color = this.trafo?.color ?? new Color(0x000000);
    return color.clone().offsetHSL(0, 0, -0.02 * Math.sqrt(this.index));
  }

  get logKey() {
    return "Kabel - " + this.index;
  }

  getBox(): Box3 {
    return this.box.clone();
  }

  /**
   * gibt die Size im eigenen lokalen Koordinatensystem zurück
   * @returns {THREE.Vector3}
   */
  getSize(): Vector3 {
    return this.getBox().getSize(v3());
  }

  get isTrafoKabel() {
    return this.startAnschluss == "Trafo" && this.länge <= TRAFO_KABELLÄNGE;
  }

  createJaco3d() {
    return new Stromkabel3d(this);
  }
}
